var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSubscriptionIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_8663",
    "data-name": "Group 8663",
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.001,
    height: 17.001,
    viewBox: "0 0 17.001 17.001",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_3347",
    "data-name": "Path 3347",
    d: "M0,0H17V17H0Z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3348",
    "data-name": "Path 3348",
    d: "M14.042,16.167H4.125A2.125,2.125,0,0,1,2,14.042V2.708A.708.708,0,0,1,2.708,2h9.917a.708.708,0,0,1,.708.708v8.5h2.833v2.833A2.125,2.125,0,0,1,14.042,16.167Zm-.708-3.542v1.417a.708.708,0,0,0,1.417,0V12.626Zm-1.417,2.125V3.417h-8.5V14.042a.708.708,0,0,0,.708.708ZM4.833,5.542H10.5V6.959H4.833Zm0,2.833H10.5V9.792H4.833Zm0,2.833H8.375v1.417H4.833Z",
    transform: "translate(-0.583 -0.583)",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubscriptionIcon);
export default __webpack_public_path__ + "static/media/subscriptionIcon.ea7aee8f44af7f52f770b5773fa5874e.svg";
export { ForwardRef as ReactComponent };